// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"50":"datadogProfiler","133":"datadogRecorder"}[chunkId] || chunkId) + "." + {"50":"47ded520","133":"c7299b79","787":"26046964"}[chunkId] + ".chunk.js";
};